import React from 'react';
import store from '../../common/store';
import {changePage} from '../../common/actions/page-actions';

import Button from '../../components/Button';

import Logo from './logo.svg';

import './styles.scss';

class Start extends React.Component {
    handleClick = () => {
      store.dispatch(changePage(1));
    }

    render() {
        return (
          <div className="start">
      			<div className="start__content">
      				<img src={Logo}  alt="Капсула mail.ru" className="start__logo" />
      				<h1 className="start__title">Какой вы друг?</h1>
      				<p className="start__text">
      					Этот тест расскажет, как вы&nbsp;умеете дружить.<br />
      					Нужно просто выбирать картинки&nbsp;&mdash; только честно! А&nbsp;ещё в&nbsp;конце вас ждёт сюрприз: поделитесь результатом с&nbsp;друзьями, оставьте почту и&nbsp;примите участие в&nbsp;розыгрыше умной колонки Капсула с&nbsp;Марусей внутри.
      				</p>
      				<div className="start__steps">
      					<div><div className="start__stepnum -n1">1</div>Пройдите наш<br />дружелюбный<br />тест</div>
      					<div><div className="start__stepnum -n2">2</div>Расскажите<br />друзьям и&nbsp;<br />оставьте почту</div>
      					<div><div className="start__stepnum -n3">3</div>Выиграйте<br />умную колонку<br />с&nbsp;Марусей</div>
      				</div>
              <Button
                  class="-orange -size-l"
                  name="давайте начнём"
                  onClick={this.handleClick}
									xray="start_button"
              />
              <div className="start__rules">
								<a href="./static/files/Pravila_Aktsii_Ko_Dnyu_Druzei_774_Final.pdf" target="_blank" rel="noopener noreferrer" data-xray-click="terms_link">Правила акции</a>
							</div>
      			</div>
      		</div>
        )
    }
}

export default Start;
